import { ToolsResponse } from '@/types/service-response'

export class Tools {
  public constructor (
    readonly code: string,
    readonly label: string,
    readonly question: string
  ) {}

  static createFromResponse (responseData: ToolsResponse[]): Array<Tools> {
    let result: Array<Tools> = []
    if (responseData) {
      result = responseData.map((item: ToolsResponse ) => {
        return new Tools(
          item.Code ? item.Code : '',
          item.Bezeichnung ? item.Bezeichnung : '',
          item.Frage ? item.Frage : ''
        )
      })
    }
    return result
  }
}
